export default import.meta.ROLLUP_FILE_URL_WJPk6ZLle63eUc7Ce6PXQA